import LoadingSpinner from './loading-spinner';
export default LoadingSpinner;